"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Command = void 0;
var Command;
(function (Command) {
    Command["AddAlbumItems"] = "AddAlbumItemsCommand";
    Command["AddEntityRelation"] = "AddEntityRelationCommand";
    Command["AddFilterToDirectory"] = "AddFilterToDirectoryCommand";
    Command["AddFilterToPage"] = "AddFilterToPageCommand";
    Command["AddLayoutToSlot"] = "AddLayoutToSlotCommand";
    Command["AddMenuItem"] = "AddMenuItemCommand";
    Command["AddModuleToSlot"] = "AddModuleToSlotCommand";
    Command["AddReferenceFieldItems"] = "AddReferenceFieldItemsCommand";
    Command["AddSelectionEntityTypes"] = "AddSelectionEntityTypesCommand";
    Command["AddSelectionItems"] = "AddSelectionItemsCommand";
    Command["AddSiteDirectory"] = "AddSiteDirectoryCommand";
    Command["AddSiteMenu"] = "AddSiteMenuCommand";
    Command["AddSitePage"] = "AddSitePageCommand";
    Command["AddStoryPart"] = "AddStoryPartCommand";
    Command["AddTranslation"] = "AddTranslationCommand";
    Command["AddVariablesToDirectory"] = "AddVariablesToDirectoryCommand";
    Command["AddVariablesToMenu"] = "AddVariablesToMenuCommand";
    Command["AddVariablesToPage"] = "AddVariablesToPageCommand";
    Command["Archive"] = "ArchiveCommand";
    Command["Batch"] = "BatchCommand";
    Command["ChangePageTemplate"] = "ChangePageTemplateCommand";
    Command["ChangeTranslation"] = "ChangeTranslationCommand";
    Command["ClaimStoryTranslationRequest"] = "ClaimStoryTranslationRequestCommand";
    Command["CloneAlbum"] = "CloneAlbumCommand";
    Command["CloneCustomEntity"] = "CloneCustomEntityCommand";
    Command["CloneDocument"] = "CloneDocumentCommand";
    Command["ClonePhoto"] = "ClonePhotoCommand";
    Command["CloneSelection"] = "CloneSelectionCommand";
    Command["CloneStory"] = "CloneStoryCommand";
    Command["CloneTag"] = "CloneTagCommand";
    Command["CopyDirectory"] = "CopyDirectoryCommand";
    Command["CopyMenu"] = "CopyMenuCommand";
    Command["CopyModule"] = "CopyModuleCommand";
    Command["CopyLayout"] = "CopyLayoutCommand";
    Command["CopyPage"] = "CopyPageCommand";
    Command["CopySiteDirectory"] = "CopySiteDirectoryCommand";
    Command["CopySiteMenu"] = "CopySiteMenuCommand";
    Command["CopySitePage"] = "CopySitePageCommand";
    Command["CreateAbsoluteLinkRule"] = "CreateAbsoluteLinkRuleCommand";
    Command["CreateAlbum"] = "CreateAlbumCommand";
    Command["CreateCustomEntity"] = "CreateCustomEntityCommand";
    Command["CreateCustomEntityTag"] = "CreateCustomEntityTagCommand";
    Command["CreateDirectory"] = "CreateDirectoryCommand";
    Command["CreateDocument"] = "CreateDocumentCommand";
    Command["CreateExternalTag"] = "CreateExternalTagCommand";
    Command["CreateLinkRuleForPage"] = "CreateLinkRuleForPageCommand";
    Command["CreateMenu"] = "CreateMenuCommand";
    Command["CreatePage"] = "CreatePageCommand";
    Command["CreatePhoto"] = "CreatePhotoCommand";
    Command["CreateSelection"] = "CreateSelectionCommand";
    Command["CreateStory"] = "CreateStoryCommand";
    Command["CreateTag"] = "CreateTagCommand";
    Command["DeleteAlbumItems"] = "DeleteAlbumItemsCommand";
    Command["DeleteDirectoryVariables"] = "DeleteDirectoryVariablesCommand";
    Command["DeleteFilterFromDirectory"] = "DeleteFilterFromDirectoryCommand";
    Command["DeleteFilterFromPage"] = "DeleteFilterFromPageCommand";
    Command["DeleteLayoutFromPage"] = "DeleteLayoutFromPageCommand";
    Command["DeleteMenuItem"] = "DeleteMenuItemCommand";
    Command["DeleteMenuVariables"] = "DeleteMenuVariablesCommand";
    Command["DeleteModuleFromPage"] = "DeleteModuleFromPageCommand";
    Command["DeletePageVariables"] = "DeletePageVariablesCommand";
    Command["DeleteSelectionItems"] = "DeleteSelectionItemsCommand";
    Command["DeleteStoryPart"] = "DeleteStoryPartCommand";
    Command["DisableLinkRule"] = "DisableLinkRuleCommand";
    Command["EnsureTag"] = "EnsureTagCommand";
    Command["ExportLinkRules"] = "ExportLinkRulesCommand";
    Command["ExportNode"] = "ExportNodeCommand";
    Command["ExtractPhotoMetadata"] = "ExtractPhotoMetadataCommand";
    Command["IgnoreFilterForDirectory"] = "IgnoreFilterForDirectoryCommand";
    Command["IgnoreFilterForPage"] = "IgnoreFilterForPageCommand";
    Command["ImportExistingDirectory"] = "ImportExistingDirectoryCommand";
    Command["ImportExistingMenu"] = "ImportExistingMenuCommand";
    Command["ImportExistingPage"] = "ImportExistingPageCommand";
    Command["ImportFeeds"] = "ImportFeedsCommand";
    Command["ImportNewDirectory"] = "ImportNewDirectoryCommand";
    Command["ImportNewMenu"] = "ImportNewMenuCommand";
    Command["ImportNewPage"] = "ImportNewPageCommand";
    Command["ImportNode"] = "ImportNodeCommand";
    Command["LoadSiteAssets"] = "LoadSiteAssetsCommand";
    Command["ModifyLinkRuleUrlPattern"] = "ModifyLinkRuleUrlPatternCommand";
    Command["MoveAlbumItem"] = "MoveAlbumItemCommand";
    Command["MoveEntityRelation"] = "MoveEntityRelationCommand";
    Command["MoveLayout"] = "MoveLayoutCommand";
    Command["MoveMenuItem"] = "MoveMenuItemCommand";
    Command["MoveModule"] = "MoveModuleCommand";
    Command["MoveReferenceFieldItem"] = "MoveReferenceFieldItemCommand";
    Command["MoveSelectionItem"] = "MoveSelectionItemCommand";
    Command["MoveSiteDirectory"] = "MoveSiteDirectoryCommand";
    Command["MoveSiteMenu"] = "MoveSiteMenuCommand";
    Command["MoveSitePage"] = "MoveSitePageCommand";
    Command["MoveStoryPart"] = "MoveStoryPartCommand";
    Command["PickSelectionItem"] = "PickSelectionItemCommand";
    Command["PinSelectionItem"] = "PinSelectionItemCommand";
    Command["Publish"] = "PublishCommand";
    Command["PublishDirectory"] = "PublishDirectoryCommand";
    Command["PublishMenu"] = "PublishMenuCommand";
    Command["PublishPage"] = "PublishPageCommand";
    Command["RemoveEntityRelation"] = "RemoveEntityRelationCommand";
    Command["RemoveLinkRuleFromPage"] = "RemoveLinkRuleFromPageCommand";
    Command["RemoveReferenceFieldItems"] = "RemoveReferenceFieldItemsCommand";
    Command["RemoveSelectionEntityTypes"] = "RemoveSelectionEntityTypesCommand";
    Command["RemoveSiteDirectory"] = "RemoveSiteDirectoryCommand";
    Command["RemoveSiteMenu"] = "RemoveSiteMenuCommand";
    Command["RemoveSitePage"] = "RemoveSitePageCommand";
    Command["RemoveTranslation"] = "RemoveTranslationCommand";
    Command["RenameSiteDirectory"] = "RenameSiteDirectoryCommand";
    Command["RenameSiteMenu"] = "RenameSiteMenuCommand";
    Command["RenameSitePage"] = "RenameSitePageCommand";
    Command["Restore"] = "RestoreCommand";
    Command["RestoreFilterForDirectory"] = "RestoreFilterForDirectoryCommand";
    Command["RestoreFilterForPage"] = "RestoreFilterForPageCommand";
    Command["Rollback"] = "RollbackCommand";
    Command["Schedule"] = "ScheduleCommand";
    Command["CancelScheduled"] = "CancelScheduledCommand";
    Command["SendRequestToTranslationTool"] = "SendRequestToTranslationToolCommand";
    Command["SendStoryTranslationRequest"] = "SendStoryTranslationRequestCommand";
    Command["SetContentDate"] = "SetContentDateCommand";
    Command["SetContext"] = "SetContextCommand";
    Command["SetContextualFields"] = "SetContextualFieldsCommand";
    Command["SetDescription"] = "SetDescriptionCommand";
    Command["SetDirectoryMetadata"] = "SetDirectoryMetadataCommand";
    Command["SetDirectoryUriParameter"] = "SetDirectoryUriParameterCommand";
    Command["SetEntityAuthorizationGroup"] = "SetEntityAuthorizationGroupCommand";
    Command["SetExtendedFields"] = "SetExtendedFieldsCommand";
    Command["SetExtraData"] = "SetExtraDataCommand";
    Command["SetFeatured"] = "SetFeaturedCommand";
    Command["SetFile"] = "SetFileCommand";
    Command["SetLayoutProperties"] = "SetLayoutPropertiesCommand";
    Command["SetLinkRuleDescription"] = "SetLinkRuleDescriptionCommand";
    Command["SetMenuDescription"] = "SetMenuDescriptionCommand";
    Command["SetMenuUriParameter"] = "SetMenuUriParameterCommand";
    Command["SetModuleImportance"] = "SetModuleImportanceCommand";
    Command["SetModuleLabel"] = "SetModuleLabelCommand";
    Command["SetModuleProperties"] = "SetModulePropertiesCommand";
    Command["SetModuleTranslatableProperties"] = "SetModuleTranslatablePropertiesCommand";
    Command["SetPageAlias"] = "SetPageAliasCommand";
    Command["SetPageMetadata"] = "SetPageMetadataCommand";
    Command["SetPageUriParameter"] = "SetPageUriParameterCommand";
    Command["SetPhotoCropArea"] = "SetPhotoCropAreaCommand";
    Command["SetPhotoGravity"] = "SetPhotoGravityCommand";
    Command["SetPublicAvailability"] = "SetPublicAvailabilityCommand";
    Command["SetSelectionLimit"] = "SetSelectionLimitCommand";
    Command["SetSelectionMaxItems"] = "SetSelectionMaxItemsCommand";
    Command["SetSiteItemVisibility"] = "SetSiteItemVisibilityCommand";
    Command["SetSlug"] = "SetSlugCommand";
    Command["SetStoryHeadline"] = "SetStoryHeadlineCommand";
    Command["SetStoryPartExtendedFields"] = "SetStoryPartExtendedFieldsCommand";
    Command["SetStoryThumbnail"] = "SetStoryThumbnailCommand";
    Command["SetThumbnail"] = "SetThumbnailCommand";
    Command["SetTitle"] = "SetTitleCommand";
    Command["SetTranslationVisibility"] = "SetTranslationVisibilityCommand";
    Command["SetUnlistedAvailability"] = "SetUnlistedAvailabilityCommand";
    Command["SetUriParameter"] = "SetUriParameterCommand";
    Command["SetUriSegmentTranslation"] = "SetUriSegmentTranslationCommand";
    Command["SetWorkflowFields"] = "SetWorkflowFieldsCommand";
    Command["SyncTag"] = "SyncTagCommand";
    Command["UnPinSelectionItem"] = "UnPinSelectionItemCommand";
    Command["UnPublish"] = "UnPublishCommand";
    Command["UnPublishDirectory"] = "UnPublishDirectoryCommand";
    Command["UnPublishMenu"] = "UnPublishMenuCommand";
    Command["UnPublishPage"] = "UnPublishPageCommand";
    Command["UnsetContext"] = "UnsetContextCommand";
    Command["UnsetContextualFields"] = "UnsetContextualFieldsCommand";
    Command["UnsetDirectoryMetadata"] = "UnsetDirectoryMetadataCommand";
    Command["UnsetEntityAuthorizationGroup"] = "UnsetEntityAuthorizationGroupCommand";
    Command["UnsetFeatured"] = "UnsetFeaturedCommand";
    Command["UnsetLinkRuleDescription"] = "UnsetLinkRuleDescriptionCommand";
    Command["UnsetPageAlias"] = "UnsetPageAliasCommand";
    Command["UnsetPageMetadata"] = "UnsetPageMetadataCommand";
    Command["UnsetPhotoCropArea"] = "UnsetPhotoCropAreaCommand";
    Command["UnsetPhotoGravity"] = "UnsetPhotoGravityCommand";
    Command["UnsetSelectionLimit"] = "UnsetSelectionLimitCommand";
    Command["UnsetStoryThumbnail"] = "UnsetStoryThumbnailCommand";
    Command["UnsetThumbnail"] = "UnsetThumbnailCommand";
    Command["UnsetUriSegmentTranslation"] = "UnsetUriSegmentTranslationCommand";
    Command["UpdateDirectoryFilter"] = "UpdateDirectoryFilterCommand";
    Command["UpdateDirectoryVariables"] = "UpdateDirectoryVariablesCommand";
    Command["UpdateLinkRuleEntityType"] = "UpdateLinkRuleEntityTypeCommand";
    Command["UpdateLinkRuleLinkedPage"] = "UpdateLinkRuleLinkedPageCommand";
    Command["UpdateMenuItem"] = "UpdateMenuItemCommand";
    Command["UpdateMenuVariables"] = "UpdateMenuVariablesCommand";
    Command["UnsetModuleTranslatableProperty"] = "UnsetModuleTranslatablePropertyCommand";
    Command["UpdatePageFilter"] = "UpdatePageFilterCommand";
    Command["UpdatePageVariables"] = "UpdatePageVariablesCommand";
    Command["UpdateStoryPart"] = "UpdateStoryPartCommand";
    Command["UploadDocument"] = "UploadDocumentCommand";
    Command["UploadPhoto"] = "UploadPhotoCommand";
    Command["UpdateLinkRuleProperties"] = "UpdateLinkRulePropertiesCommand";
    Command["ResetLinkRuleProperties"] = "ResetLinkRulePropertiesCommand";
})(Command || (exports.Command = Command = {}));
//# sourceMappingURL=commands.js.map